import { Box, Flex } from '@chakra-ui/react';

import { BrowserRouter as Router, Route, Routes, useLocation,Navigate, useNavigate, matchPath } from "react-router-dom";
import { useEffect, useState } from 'react'; 

import SuperRouter from './SuperRouter';
import SuperuserLogin from "../Components/SuperuserLogin";
import { TenantContextProvider, useTenant } from './TenantContextProvider';
import TenantPlatformRouter from './TenantPlatformRouter';
import { jwtDecode } from "jwt-decode";
import { useToast } from "@chakra-ui/react";
import ChangePasswordSuper from '../Superuser/ChangePasswordSuper';
import NavBarPlatform from '../Common/NavBarPlatform';
import TenantSelector from '../TenantSelector';
import axios from "axios";
import { Tenant } from "../Common/types";
import { TOKEN_UPDATED_EVENT } from '../../apiClient'; // adjust path
import { PlatformSidebarProvider } from '../Common/PrivateSidebarContext';


const SECRET_KEY_SUPER = process.env.REACT_APP_SUPER_ROUTE_KEY; // Define your secret key for access

// Helper function to check if the access key is valid
const useHasValidSuperAccessKey = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get('access_key') === SECRET_KEY_SUPER;
};

const useTenantSlugFromURL = (): string | null => {
  const location = useLocation();

  const match = matchPath("/platform/:tenantSlug/*", location.pathname);
  return match?.params?.tenantSlug || null;
};

/* const useTokenExpiration = (
  token: string | null,
  onLogout: () => void
) => {
  const toast = useToast();

  useEffect(() => {
    if (!token) return;

    try {
      const decoded: { exp: number } = jwtDecode(token); // Decode the token to get the expiration time
      const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
      const timeRemaining = decoded.exp - currentTime; // Calculate time left until expiration

      if (timeRemaining > 0) {
        // Show a warning toast 10 minutes before expiration (if timeRemaining is more than 10 minutes)
        if (timeRemaining > 600) {
          const warningTimeout = setTimeout(() => {
            toast({
              title: "Session Expiring Soon",
              description:
                "Your session will expire in 10 minutes. Please save your work.",
              status: "warning",
              duration: 9000, // Toast stays for 9 seconds
              isClosable: true,
            });
          }, (timeRemaining - 600) * 1000); // Trigger 10 minutes before expiration

          // Cleanup warning timeout
          return () => clearTimeout(warningTimeout);
        }

        // Set timeout to logout when token expires
        const logoutTimeout = setTimeout(() => {
          console.log("Token expired. Logging out...");
          onLogout();
        }, timeRemaining * 1000);

        // Cleanup logout timeout
        return () => clearTimeout(logoutTimeout);
      } else {
        onLogout(); // Token already expired, logout immediately
      }
    } catch (err) {
      console.error("Failed to decode token:", err);
      onLogout(); // In case of error, consider the token invalid and logout
    }
  }, [token, onLogout, toast]);
};
 */


const useTokenExpiration = (token: string | null) => {
  const toast = useToast();

  useEffect(() => {
    if (!token) return;

    try {
      const decoded: { exp: number } = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      const timeRemaining = decoded.exp - currentTime;

      if (timeRemaining > 600) {
        const warningTimeout = setTimeout(() => {
          toast({
            title: "Session Refreshing",
            description: "Keeping your session active...",
            status: "info",
            duration: 4000,
            isClosable: true,
          });
        }, (timeRemaining - 600) * 1000);

        return () => clearTimeout(warningTimeout);
      }
    } catch (err) {
      console.error("Failed to decode token:", err);
    }
  }, [token, toast]);
};
interface TokenData {
  sub: string;
  role_id: number;
  tenant_id: string;
  is_initial_password: boolean;
}

// Utility function to decode token
const decodeToken = (token: string | null): TokenData | null => {
  try {
      return token ? jwtDecode<TokenData>(token) : null;
  } catch (error) {
      console.error("Failed to decode token:", error);
      return null;
  }
};


const PlatformRouter = () => {

    const location = useLocation();

    const navigate = useNavigate();
    const [token, setToken] = useState<string | null>(localStorage.getItem("token"));
    const [userInitials, setUserInitials] = useState<string | null>(null);

 //   const { setTenant } = useTenant();

    const hasValidSuperAccess = useHasValidSuperAccessKey(); // <- Move to top

    // Decode token to get the `is_initial_password` flag
    const decodedToken = decodeToken(token);
    const isInitialPassword = decodedToken?.is_initial_password ?? false;
    const isSuperUser = decodedToken?.role_id==1 ;
  //  const tenantSlug = useTenantSlugFromURL();

    const [tenantName, setTenantName] = useState<string | null>(null);
    const [logoUrl, setLogoUrl] = useState<string | null>(null);
    const [tenantSlug, setTenantSlug] = useState<string | null>(null);

      const fetchTenant = async (tenant_id : number) => {
        try {
            const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
           
          const response = await axios.get(`${apiurl}/tenant/${tenant_id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
       //   setTenant(response.data);
        setTenantSlug(response.data.slug);
        setTenantName(response.data.name);
        setLogoUrl(response.data.logo_image_url);
          console.log("Tenant Data Fetched", response.data)
        } catch (error) {
          console.error("Failed to load enrolled students", error);
        }
      };

/*     useEffect(() => {
      const tenantMatch = matchPath("/platform/:tenantSlug/*", location.pathname);
      if (tenantMatch?.params?.tenantSlug) {
        const slug = tenantMatch.params.tenantSlug;
        localStorage.setItem("tenantSlug", slug);
        setTenantSlug(slug);
      } else {
        localStorage.removeItem("tenantSlug");
     //   setTenant(null);
        setTenantSlug(null);
        setTenantName(null);
        setLogoUrl(null);
      }
    }, [location.pathname]); */

    useEffect(() => {
  if (!token) {
    const tenantMatch = matchPath("/platform/:tenantSlug/*", location.pathname);
    if (tenantMatch?.params?.tenantSlug) {
      const slug = tenantMatch.params.tenantSlug;
      localStorage.setItem("tenantSlug", slug);
      setTenantSlug(slug);
    } else {
      localStorage.removeItem("tenantSlug");
      setTenantSlug(null);
      setTenantName(null);
      setLogoUrl(null);
    }
  }
}, [location.pathname, token]);
  
    useEffect(() => {
      if (token) {
        try {
          const decoded: { sub: string, tenant_id:number } = jwtDecode(token); // Decode JWT
          const username = decoded.sub || ""; // Default to an empty string if sub is undefined
  
          // Extract initials (first and last character or first two letters)
          const initials =
          username.length > 1
            ? (username[0] + username[username.length - 1]).toUpperCase()
            : username[0]?.toUpperCase() || "";
  
          setUserInitials(initials || decoded.sub); // Use initials or full name

          fetchTenant(decoded.tenant_id);

        } catch (err) {
          console.error("Failed to decode token:", err);
          setUserInitials(null);
        }
      } else {
        setUserInitials(null);
      }
    }, [token]);

    useEffect(() => {
  const handleStorageChange = (e: StorageEvent) => {
    if (e.key === "token") {
      const newToken = localStorage.getItem("token");
      setToken(newToken);
    }
  };

  window.addEventListener("storage", handleStorageChange);
  return () => window.removeEventListener("storage", handleStorageChange);
}, []);

useEffect(() => {
  const handleTokenUpdated = () => {
    const current = localStorage.getItem("token");
    setToken(current);
  };

  window.addEventListener(TOKEN_UPDATED_EVENT, handleTokenUpdated);
  return () => window.removeEventListener(TOKEN_UPDATED_EVENT, handleTokenUpdated);
}, []);
  
const handleLogin = (newToken: string, newRefreshToken: string) => {
  localStorage.setItem("token", newToken);
  localStorage.setItem("refresh_token", newRefreshToken);
  setToken(newToken);
};
const handleLogout = async () => {
  const refreshToken = localStorage.getItem("refresh_token");

  if (refreshToken) {
    try {
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      await axios.post(`${apiurl}/logout`, { refresh_token: refreshToken });
    } catch (err) {
      console.error("Failed to revoke refresh token:", err);
    }
  }

  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  setToken(null);
  setUserInitials(null);

  if (isSuperUser) {
    navigate(`/platform/`, { replace: true });
  } else {
    const tenantSlug = localStorage.getItem("tenantSlug");
    navigate(`/platform/${tenantSlug}/login/`, { replace: true });
  }
};
  
    const isAuthenticated = !!token; 
  
    useTokenExpiration(token);

    return (
       <PlatformSidebarProvider>
        <Box >
        <NavBarPlatform
        isAuthenticated={isAuthenticated}
        onLogout={handleLogout}
        userInitials={userInitials}
       tenantName={tenantName}
        logoUrl={logoUrl}
        tenantSlug={tenantSlug}  // ✅ PASS THIS TOO
        />
           
          {/* Main content area with flexible width */}
          <Box overflowY="auto">
            <Routes>

              <Route path="/" element={<TenantSelector />} />

                <Route
                    path="super/*"
                    element={
                    isAuthenticated ? (
                        isInitialPassword ? (
                        <Navigate to="change-password" replace />
                        ) : (
                        <SuperRouter />
                        )
                    ) : (
                        <Navigate to="login/super" replace />
                    )
                    }
                />
                <Route
                    path="super/login"
                    element={
                    hasValidSuperAccess ? (
                        <SuperuserLogin onLogin={handleLogin} />
                    ) : (
                        <Navigate to="/" replace />
                    )
                    }
                />
                <Route
                    path="super/change-password"
                    element={<ChangePasswordSuper handleLogout={handleLogout} />}
                />

                {/* Tenant Routes */}
                <Route
                path=":tenantSlug/*"
                element={
                    <TenantContextProvider>
                        <TenantPlatformRouter 
                          onLogin={handleLogin}  
                          onLogout={handleLogout}
                          isAuthenticated={isAuthenticated}
                          setNavBarTenantInfo={({ tenantName, logoUrl, tenantSlug }) => {
                            setTenantName(tenantName);
                            setLogoUrl(logoUrl);
                            setTenantSlug(tenantSlug);  // ✅ ADD THIS
                          }}
                          />
                    </TenantContextProvider>
                }
                />
            </Routes>
          </Box>
          
      </Box>
      </PlatformSidebarProvider>
      
    );
  };

export default PlatformRouter;
